export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/ou-imported/ou-imported.controller.js